module.exports = __webpack_public_path__ + "assets/crane-operator.svg?c857525be2e8ac29cd8a2f76ce5162a6";